import { createContext, useContext, type ReactNode } from 'react'

import { TRUST_LOCALE_KEY } from '../constants/storage'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { type Locale } from '../i18n/I18nProvider'

type TranslationContextData = [
  locale: Locale,
  setLocale: (locale: Locale) => void
]

interface TranslationProviderProps {
  children: ReactNode
}

const TranslationContext = createContext<TranslationContextData>(
  {} as TranslationContextData
)

export const TranslationProvider = ({ children }: TranslationProviderProps) => {
  const [locale, setLocale] = useLocalStorage<Locale>(TRUST_LOCALE_KEY, 'pt')

  return (
    <TranslationContext.Provider value={[locale, setLocale]}>
      {children}
    </TranslationContext.Provider>
  )
}

export const useTranslation = () => {
  return useContext(TranslationContext)
}
